import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
    // },
    // {
    //   id: 'reports.inventory',
    //   title: 'Item Ledger',
    //   type: 'basic',
    //   icon: 'heroicons_outline:clipboard-document-list',
    //   link: '/item-ledger/list'
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
    // },
    // {
    //   id: 'reports.inventory',
    //   title: 'Item Ledger',
    //   type: 'basic',
    //   icon: 'heroicons_outline:clipboard-document-list',
    //   link: '/item-ledger/list'
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  // {
  //     id   : 'example',
  //     title: 'Example',
  //     type : 'basic',
  //     icon : 'heroicons_outline:chart-pie',
  //     link : '/example'
  // },
  //------------------------------------------------
  // {
  //   id: 'reports.inventory',
  //   title: 'Item Ledger',
  //   type: 'basic',
  //   icon: 'heroicons_outline:clipboard-document-list',
  //   link: '/item-ledger/list'
  // },
  {
    id: 'masters',
    title: 'Masters',
    subtitle: '',
    type: 'group',
    icon: 'heroicons_outline:folder',
    children: [
      {
        id: 'masters.items',
        title: 'Items',
        type: 'basic',
        icon: 'heroicons_outline:cube',
        link: '/item',
        subtitle: 'Ctrl+F12',
      },
      {
        id: 'masters.company',
        title: 'Company',
        type: 'basic',
        icon: 'heroicons_outline:building-office',
        link: '/company',
      },
      {
        id: 'masters.companyGroup',
        title: 'Company Group',
        type: 'basic',
        icon: 'heroicons_outline:squares-2x2',
        link: '/company-group',
      },
      {
        id: 'masters.generics',
        title: 'Generics',
        type: 'basic',
        icon: 'heroicons_outline:rectangle-stack',
        link: '/generics',
      },
      {
        id: 'masters.customers',
        title: 'Customers',
        type: 'basic',
        icon: 'heroicons_outline:user',
        link: '/customers',
        subtitle: 'Ctrl+F11',
      },
      {
        id: 'masters.suppliers',
        title: 'Suppliers',
        type: 'basic',
        icon: 'heroicons_outline:truck',
        link: '/supplier',
        subtitle: 'Ctrl+F9',
      },
      {
        id: 'masters.doctors',
        title: 'Doctors',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/doctor',
      },
      {
        id: 'masters.therapeuticCategory',
        title: 'Therapeutic Category',
        type: 'basic',
        icon: 'heroicons_outline:beaker',
        link: '/therapeutic-category',
      },
      {
        id: 'masters.category',
        title: 'Category',
        type: 'basic',
        icon: 'heroicons_outline:tag',
        link: '/category',
      },
      {
        id: 'masters.ledgerMaster',
        title: 'Ledger Master',
        type: 'basic',
        icon: 'heroicons_outline:book-open',
        link: '/ledger/list',
      },
      {
        id: 'masters.ledgers',
        title: 'Ledgers',
        type: 'collapsable',
        icon: 'heroicons_outline:banknotes',
        children: [
          {
            id: 'masters.ledgers.general',
            title: 'General Ledger',
            type: 'basic',
            icon: 'heroicons_outline:document-text',
            link: '/masters/ledgers/general',
            subtitle: 'Shift+Ins',
          },
          {
            id: 'masters.ledgers.cashbank',
            title: 'Cash / Bank Books',
            type: 'basic',
            icon: 'heroicons_outline:credit-card',
            link: '/masters/ledgers/cash-bank',
            subtitle: 'Ctrl+Ins',
          },
          {
            id: 'masters.ledgers.sale',
            title: 'Sale Ledger',
            type: 'basic',
            icon: 'heroicons_outline:document',
            link: '/masters/ledgers/sale',
          },
          {
            id: 'masters.ledgers.purchase',
            title: 'Purchase Ledger',
            type: 'basic',
            icon: 'heroicons_outline:document',
            link: '/masters/ledgers/purchase',
          },
        ],
      },
      {
        id: 'masters.allAccounts',
        title: 'All Account Ledgers',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/masters/all-account-ledgers',
        subtitle: 'Ctrl+A',
      },
      {
        id: 'masters.balanceSheetGroups',
        title: 'Balance Sheet Groups',
        type: 'basic',
        icon: 'heroicons_outline:scale',
        link: '/masters/balance-sheet-groups',
      },
      {
        id: 'masters.area',
        title: 'Area',
        type: 'basic',
        icon: 'heroicons_outline:map-pin',
        link: '/masters/area',
      },
      {
        id: 'masters.category',
        title: 'Category',
        type: 'basic',
        icon: 'heroicons_outline:tag',
        link: '/category',
      },
      {
        id: 'masters.cheque-master',
        title: 'Cheque-Master',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/cheques',
      },
      {
        id: 'masters.Bank-Master',
        title: 'Bank-Master',
        type: 'basic',
        icon: 'heroicons_outline:banknotes',
        link: '/banks',
      },
      {
        id: 'masters.accountsGroup',
        title: 'Accounts Group',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar-square',
        link: '/accounts-group',
      },
      {
        id: 'masters.others',
        title: 'Others',
        type: 'collapsable',
        icon: 'heroicons_outline:ellipsis-vertical',
        children: [
          {
            id: 'masters.others.personalDirectory',
            title: 'Personal Directory',
            type: 'basic',
            icon: 'heroicons_outline:address-book',
            link: '/masters/others/personal-directory',
            subtitle: 'Alt+Bkp',
          },
          {
            id: 'masters.others.generalReminders',
            title: 'General Reminders',
            type: 'basic',
            icon: 'heroicons_outline:bell',
            link: '/masters/others/general-reminders',
            subtitle: 'Shift+Del',
          },
          {
            id: 'masters.others.generalNotebook',
            title: 'General Notebook',
            type: 'basic',
            icon: 'heroicons_outline:book-open',
            link: '/masters/others/general-notebook',
          },
          {
            id: 'masters.others.specialist',
            title: 'Specialist',
            type: 'basic',
            icon: 'heroicons_outline:user-circle',
            link: '/masters/others/specialist',
          },
          {
            id: 'masters.others.itemGroup',
            title: 'Item Group',
            type: 'basic',
            icon: 'heroicons_outline:rectangle-group',
            link: '/masters/others/item-group',
          },
          {
            id: 'masters.others.itemCategory',
            title: 'Item-Category',
            type: 'basic',
            icon: 'heroicons_outline:tag',
            link: '/masters/others/item-category',
          },
          {
            id: 'masters.others.itemSubCategory',
            title: 'Item-Sub Cate',
            type: 'basic',
            icon: 'heroicons_outline:tag',
            link: '/masters/others/item-sub-category',
          },
          {
            id: 'masters.others.ward',
            title: 'Ward',
            type: 'basic',
            icon: 'heroicons_outline:building-library',
            link: '/masters/others/ward',
          },
          {
            id: 'masters.others.therapeuticCategory',
            title: 'Therapeutic Category',
            type: 'basic',
            icon: 'heroicons_outline:beaker',
            link: '/masters/others/therapeutic-category',
          },
          {
            id: 'masters.others.clinicalClassification',
            title: 'Clinical Classification',
            type: 'basic',
            icon: 'heroicons_outline:academic-cap',
            link: '/masters/others/clinical-classification',
          },
          {
            id: 'masters.others.doctorGroup',
            title: 'Doctor Group',
            type: 'basic',
            icon: 'heroicons_outline:user-group',
            link: '/masters/others/doctor-group',
          },
          {
            id: 'masters.others.transportMaster',
            title: 'Transport Master',
            type: 'basic',
            icon: 'heroicons_outline:truck',
            link: '/masters/others/transport-master',
          },
          {
            id: 'masters.others.hsnCodeMaster',
            title: 'HSN Code Master',
            type: 'basic',
            icon: 'heroicons_outline:hashtag',
            link: '/hsn-code',
          },
          {
            id: 'masters.others.itemSchedule',
            title: 'Item Schedule',
            type: 'basic',
            icon: 'heroicons_outline:calendar-days',
            link: '/schedule',
          },
          {
            id: 'masters.others.storageRack',
            title: 'Storage Rack',
            type: 'basic',
            icon: 'heroicons_outline:rectangle-stack',
            link: '/storage-rack',
          },
        ],
      },
    ],
  },
  {
    id: 'transactions',
    title: 'Transactions',
    subtitle: '',
    type: 'group',
    icon: 'heroicons_outline:arrows-right-left',
    children: [
      {
        id: 'transactions.sale',
        title: 'Sale',
        type: 'collapsable',
        icon: 'heroicons_outline:shopping-cart',
        children: [
          {
            id: 'transactions.sale.transaction',
            title: 'Transaction',
            type: 'basic',
            subtitle: 'Ctrl+F1',
            link: 'sales/add',
          },
          {
            id: 'transactions.sale.modification',
            title: 'Modification',
            type: 'basic',
            subtitle: 'Shift+Ctrl+F1',
            link: 'sales/list',
          },
          {
            id: 'transactions.sale.orderTransaction',
            title: 'Sale Order - Transaction',
            type: 'basic',
          },
          {
            id: 'transactions.sale.orderModification',
            title: 'Sale Order - Modification',
            type: 'basic',
            subtitle: 'Ctrl+O',
          },
          {
            id: 'transactions.sale.orderToInvoice',
            title: 'Order To Sale Invoice',
            type: 'basic',
          },
          {
            id: 'transactions.sale.stockTransferTransaction',
            title: 'Stock Transfer Transaction',
            type: 'basic',
          },
          {
            id: 'transactions.sale.stockTransferModification',
            title: 'Stock Transfer Modification',
            type: 'basic',
          },
        ],
      },
      {
        id: 'transactions.purchase',
        title: 'Purchase',
        type: 'collapsable',
        icon: 'heroicons_outline:receipt-percent',
        children: [
          {
            id: 'transactions.purchase.transaction',
            title: 'Transaction',
            type: 'basic',
            subtitle: 'Ctrl+F2',
            link: 'purchase/add',
          },
          {
            id: 'transactions.purchase.modification',
            title: 'Modification',
            type: 'basic',
            subtitle: 'Shift+Ctrl+F2',
            link: 'purchase/list',
          },
        ],
      },
      {
        id: 'transactions.salesReturn',
        title: 'Sales Return',
        type: 'collapsable',
        icon: 'heroicons_outline:arrow-uturn-left',
        children: [
          {
            id: 'transactions.salesReturn.transaction',
            title: 'Transaction',
            type: 'basic',
            subtitle: 'Ctrl+F3',
            link: 'sales-return/add',
          },
          {
            id: 'transactions.salesReturn.modification',
            title: 'Modification',
            type: 'basic',
            subtitle: 'Shift+Ctrl+F3',
            link: 'sales-return/list',
          },
        ],
      },
      {
        id: 'transactions.purchaseReturn',
        title: 'Purchase Return',
        type: 'collapsable',
        icon: 'heroicons_outline:arrow-uturn-right',
        children: [
          {
            id: 'transactions.purchaseReturn.transaction',
            title: 'Transaction',
            type: 'basic',
            subtitle: 'Ctrl+F8',
            link: 'purchase-return/add',
          },
          {
            id: 'transactions.purchaseReturn.modification',
            title: 'Modification',
            type: 'basic',
            subtitle: 'Shift+Ctrl+F8',
            link: 'purchase-return/list',
          },
        ],
      },
      {
        id: 'transactions.breakageExpiry',
        title: 'Breakage/Expiry to Supplier',
        type: 'collapsable',
        icon: 'heroicons_outline:exclamation-circle',
        children: [
          {
            id: 'transactions.breakageExpiry.issuedTransaction',
            title: 'Issued - Transaction',
            type: 'basic',
            icon: 'heroicons_outline:arrow-up',
            link: '/transactions/breakage-expiry/issued-transaction',
          },
          {
            id: 'transactions.breakageExpiry.issuedModification',
            title: 'Issued - Modification',
            type: 'basic',
            icon: 'heroicons_outline:pencil',
            link: '/transactions/breakage-expiry/issued-modification',
          },
          {
            id: 'transactions.breakageExpiry.receivedTransaction',
            title: 'Received - Transaction',
            type: 'basic',
            icon: 'heroicons_outline:arrow-down',
            link: '/transactions/breakage-expiry/received-transaction',
          },
          {
            id: 'transactions.breakageExpiry.receivedModification',
            title: 'Received - Modification',
            type: 'basic',
            icon: 'heroicons_outline:pencil-square',
            link: '/transactions/breakage-expiry/received-modification',
          },
          {
            id: 'transactions.breakageExpiry.unusedDumpTransaction',
            title: 'Unused Dump - Transaction',
            type: 'basic',
            icon: 'heroicons_outline:trash',
            link: '/transactions/breakage-expiry/unused-dump-transaction',
          },
          {
            id: 'transactions.breakageExpiry.unusedDumpModification',
            title: 'Unused Dump - Modification',
            type: 'basic',
            icon: 'heroicons_outline:adjustments-horizontal',
            link: '/transactions/breakage-expiry/unused-dump-modification',
          },
        ],
      },
      {
        id: 'transactions.saleOnChallan',
        title: 'Sale on Challan',
        type: 'collapsable',
        icon: 'heroicons_outline:document-check',
        children: [
          {
            id: 'transactions.saleOnChallan.transaction',
            title: 'Transaction',
            type: 'basic',
            icon: 'heroicons_outline:document-plus',
            link: '/transactions/sale-on-challan/transaction',
          },
          {
            id: 'transactions.saleOnChallan.modification',
            title: 'Modification',
            type: 'basic',
            icon: 'heroicons_outline:pencil',
            link: '/transactions/sale-on-challan/modification',
          },
        ],
      },
      {
        id: 'transactions.purchaseOnChallan',
        title: 'Purchase on Challan',
        type: 'collapsable',
        icon: 'heroicons_outline:clipboard-document',
        children: [
          {
            id: 'transactions.purchaseOnChallan.transaction',
            title: 'Transactions',
            type: 'basic',
            icon: 'heroicons_outline:clipboard',
            link: '/transactions/purchase-on-challan/transaction',
          },
          {
            id: 'transactions.purchaseOnChallan.modification',
            title: 'Modification',
            type: 'basic',
            icon: 'heroicons_outline:pencil-square',
            link: '/transactions/purchase-on-challan/modification',
          },
        ],
      },
      {
        id: 'transactions.creditNote',
        title: 'Credit Note',
        type: 'collapsable',
        icon: 'heroicons_outline:credit-card',
        children: [
          {
            id: 'transactions.creditNote.transaction',
            title: 'Transaction',
            type: 'basic',
            icon: 'heroicons_outline:document-arrow-down',
            link: '/transactions/credit-note/transaction',
          },
          {
            id: 'transactions.creditNote.modification',
            title: 'Modification',
            type: 'basic',
            icon: 'heroicons_outline:pencil',
            link: '/transactions/credit-note/modification',
          },
        ],
      },
      {
        id: 'transactions.debitNote',
        title: 'Debit Note',
        type: 'collapsable',
        icon: 'heroicons_outline:banknotes',
        children: [
          {
            id: 'transactions.debitNote.transaction',
            title: 'Transaction',
            type: 'basic',
            icon: 'heroicons_outline:document-arrow-up',
            link: '/transactions/debit-note/transaction',
          },
          {
            id: 'transactions.debitNote.modification',
            title: 'Modification',
            type: 'basic',
            icon: 'heroicons_outline:pencil-square',
            link: '/transactions/debit-note/modification',
          },
        ],
      },
      {
        id: 'transactions.miscTransactions',
        title: 'Misc. Transactions',
        type: 'collapsable',
        icon: 'heroicons_outline:squares-2x2',
        children: [
          {
            id: 'transactions.miscTransactions.stockAdjustmentTransaction',
            title: 'Stock Adjustment - Transaction',
            type: 'basic',
            icon: 'heroicons_outline:arrows-up-down',
            link: '/transactions/misc/stock-adjustment-transaction',
          },
          {
            id: 'transactions.miscTransactions.stockAdjustmentModification',
            title: 'Stock Adjustment - Modification',
            type: 'basic',
            icon: 'heroicons_outline:pencil',
            link: '/transactions/misc/stock-adjustment-modification',
          },
          {
            id: 'transactions.miscTransactions.godownBreakageTransaction',
            title: 'Godown Breakage/Expiry - Transaction',
            type: 'basic',
            icon: 'heroicons_outline:building-storefront',
            link: '/transactions/misc/godown-breakage-transaction',
          },
          {
            id: 'transactions.miscTransactions.godownBreakageModification',
            title: 'Godown Breakage/Expiry - Modification',
            type: 'basic',
            icon: 'heroicons_outline:pencil-square',
            link: '/transactions/misc/godown-breakage-modification',
          },
        ],
      },
      {
        id: 'transactions.receiptFromCustomers',
        title: 'Receipt From Customers',
        type: 'collapsable',
        icon: 'heroicons_outline:currency-rupee',
        children: [
          {
            id: 'transactions.receiptFromCustomers.transaction',
            title: 'Transaction',
            type: 'basic',
            icon: 'heroicons_outline:arrow-down-tray',
            link: '/customer-receipts/add',
          },
          {
            id: 'transactions.receiptFromCustomers.modification',
            title: 'Modification',
            type: 'basic',
            icon: 'heroicons_outline:pencil-square',
            link: '/customer-receipts/list',
          },
        ],
      },
      {
        id: 'transactions.paymentToSuppliers',
        title: 'Payment to Suppliers',
        type: 'collapsable',
        icon: 'heroicons_outline:hand-raised',
        children: [
          {
            id: 'transactions.paymentToSuppliers.transaction',
            title: 'Transaction',
            type: 'basic',
            icon: 'heroicons_outline:arrow-up-tray',
            link: 'payment-to-suppliers/add',
          },
          {
            id: 'transactions.paymentToSuppliers.modification',
            title: 'Modification',
            type: 'basic',
            icon: 'heroicons_outline:pencil-square',
            link: 'payment-to-suppliers/list',
          },
          {
            id: 'transactions.paymentToSuppliers.chequeReturn',
            title: 'Cheque Return Unpaid',
            type: 'basic',
            icon: 'heroicons_outline:x-circle',
            link: '/transactions/payment-to-suppliers/cheque-return',
          },
        ],
      },
      {
        id: 'transactions.stockAdjustment',
        title: 'Stock Adjustment',
        type: 'collapsable',
        icon: 'heroicons_outline:arrows-up-down',
        children: [
          {
            id: 'transactions.stockAdjustment.transaction',
            title: 'Transaction',
            type: 'basic',
            link: 'stock-adjustment/add',
          },
          {
            id: 'transactions.stockAdjustment.modification',
            title: 'Modification',
            type: 'basic',
            link: 'stock-adjustment/list',
          },
        ],
      },
      {
        id: 'transactions.voucherEntry',
        title: 'Voucher Entry',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/transactions/voucher-entry',
      },
      {
        id: 'transactions.voucherPurchase',
        title: 'Voucher-Purchase (Input GST)',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-check',
        link: '/transactions/voucher-purchase',
      },
      {
        id: 'transactions.voucherIncome',
        title: 'Voucher-Income (Output GST)',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/transactions/voucher-income',
      },
      {
        id: 'transactions.multiVoucher',
        title: 'Multi Voucher',
        type: 'basic',
        icon: 'heroicons_outline:rectangle-stack',
        link: '/transactions/multi-voucher',
      },
      {
        id: 'transactions.cashDepositedWithdrawn',
        title: 'Cash Deposited/Withdrawn',
        type: 'basic',
        icon: 'heroicons_outline:arrow-path',
        link: '/transactions/cash-deposit-withdrawal',
      },
    ],
  },
  {
    id: 'reports',
    title: 'Reports',
    subtitle: '',
    type: 'group',
    icon: 'heroicons_outline:chart-bar',
    children: [
      {
        id: 'reports.customer',
        title: 'Customer Report',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/reports/customer',
      },
      {
        id: 'reports.customerLedger',
        title: 'Customer Ledger',
        type: 'basic',
        icon: 'heroicons_outline:book-open',
        link: '/reports/customer-ledger',
      },
      {
        id: 'reports.supplierLedger',
        title: 'Supplier Ledger',
        type: 'basic',
        icon: 'heroicons_outline:book-open',
        link: '/reports/supplier-ledger',
      },
      {
        id: 'reports.bankLedger',
        title: 'Bank Ledger',
        type: 'basic',
        icon: 'heroicons_outline:book-open',
        link: '/reports/bank-ledger',
      },
      {
        id: 'reports.inventory',
        title: 'Item Ledger',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/item-ledger/list',
      },

      {
        id: 'reports.purchaseOrderSummary',
        title: 'Purchase Order Summary',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/purchase-order-summary',
      },

      {
        id: 'reports.batch',
        title: 'Batch Reports',
        type: 'basic',
        icon: 'heroicons_outline:cube-transparent',
        link: '/batch-reports',
      },
      {
        id: 'payment-alerts',
        title: 'Payment Alerts',
        type: 'basic',
        icon: 'heroicons_outline:bell-alert',
        link: '/payment-alerts',
      },
      {
        id: 'marketplace-integration',
        title: 'Marketplace Integration',
        type: 'group',
        icon: 'heroicons_outline:globe-alt',
        children: [
          {
            id: 'marketplace.integrations',
            title: 'Integrations',
            type: 'basic',
            icon: 'heroicons_outline:link',
            link: '/marketplace/integrations',
          },
          {
            id: 'marketplace.orders',
            title: 'Orders',
            type: 'basic',
            icon: 'heroicons_outline:shopping-cart',
            link: '/marketplace/orders',
          },
          {
            id: 'marketplace.inventory',
            title: 'Inventory Sync',
            type: 'basic',
            icon: 'heroicons_outline:arrow-path',
            link: '/marketplace/inventory',
          },
          {
            id: 'marketplace.item-mapping',
            title: 'Item Mapping',
            type: 'basic',
            icon: 'heroicons_outline:arrows-right-left',
            link: '/marketplace/item-mapping',
          },
          {
            id: 'marketplace.logs',
            title: 'Sync Logs',
            type: 'basic',
            icon: 'heroicons_outline:document-text',
            link: '/marketplace/logs',
          },
        ],
      },
      {
        id: 'reports.ledger-impact',
        title: 'Ledger Impact Report',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/reports/ledger-impact',
      },
      {
        id: 'reports.enterprise',
        title: 'Enterprise Reports',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar-square',
        link: '/reports',
      },
      {
        id: 'reports.vendor-pricing',
        title: 'Vendor Pricing',
        type: 'collapsable',
        icon: 'heroicons_outline:currency-dollar',
        children: [
          {
            id: 'reports.vendor-pricing.upload',
            title: 'File Upload',
            type: 'basic',
            icon: 'heroicons_outline:cloud-arrow-up',
            link: '/vendor-pricing/upload',
          },
          {
            id: 'reports.vendor-pricing.comparison',
            title: 'Price Comparison',
            type: 'basic',
            icon: 'heroicons_outline:chart-bar',
            link: '/vendor-pricing/comparison',
          },
        ],
      },
    ],
  },
  //administration section
  {
    id: 'administration',
    title: 'Administration',
    subtitle: '',
    type: 'group',
    icon: 'heroicons_outline:cog-6-tooth',
    children: [
      {
        id: 'administration.on-boarding',
        title: 'On-Boarding',
        type: 'collapsable',
        icon: 'heroicons_outline:user-plus',
        children: [
          {
            id: 'administration.on-boarding.tenant.list',
            title: 'Tenent',
            type: 'basic',
            icon: 'heroicons_outline:building-office',
            link: '/on-boarding/tenant/list',
          },
          {
            id: 'administration.on-boarding.organisation',
            title: 'Organisation',
            type: 'basic',
            icon: 'heroicons_outline:globe-alt',
            link: '/on-boarding/organization/list',
          },
          {
            id: 'administration.on-boarding.store',
            title: 'Store',
            type: 'basic',
            icon: 'heroicons_outline:shopping-bag',
            link: '/on-boarding/store/list',
          },
          // {
          //   id: "administration.on-boarding.device",
          //   title: "Device",
          //   type: "basic",
          //   icon: "heroicons_outline:cpu-chip",
          //   link: "/administration/on-boarding/device",
          // },
        ],
      },
      {
        id: 'administration.user-management',
        title: 'User Management',
        type: 'collapsable',
        icon: 'heroicons_outline:users',
        children: [
          {
            id: 'administration.user-management.roles',
            title: 'Roles',
            type: 'basic',
            icon: 'heroicons_outline:tag',
            link: '/roles',
          },
          {
            id: 'administration.user-management.users',
            title: 'Users',
            type: 'basic',
            icon: 'heroicons_outline:users',
            link: '/user-management',
          },
          {
            id: 'administration.user-management.role-management',
            title: 'Role-Management',
            type: 'basic',
            icon: 'heroicons_outline:user-plus',
            link: '/role-management/list',
          },
        ],
      },
      {
        id: 'administration.audit-logs',
        title: 'Aduit Logs',
        type: 'collapsable',
        icon: 'heroicons_outline:clipboard-document-list',
        children: [
          {
            id: 'administration.audit-logs.audit-log-list',
            title: 'Audit Log List',
            type: 'basic',
            icon: 'heroicons_outline:tag',
            link: '/administration/audit-logs/audit-log-list',
          },
        ],
      },
      {
        id: 'administration.api-performance',
        title: 'API Performance',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar-square',
        link: '/api-performance',
      },
      {
        id: 'administration.subscription-plans',
        title: 'Subscription Plans',
        type: 'collapsable',
        icon: 'heroicons_outline:credit-card',
        children: [
          {
            id: 'administration.subscription-plans.list',
            title: 'Plan List',
            type: 'basic',
            icon: 'heroicons_outline:list-bullet',
            link: '/administration/subscription-plans/list',
          },
          {
            id: 'administration.subscription-plans.create',
            title: 'Create Plan',
            type: 'basic',
            icon: 'heroicons_outline:plus-circle',
            link: '/administration/subscription-plans/add',
          },
          {
            id: 'administration.subscription-plans.features',
            title: 'Plan Features',
            type: 'basic',
            icon: 'heroicons_outline:puzzle-piece',
            link: '/administration/subscription-plans/features',
          },
          {
            id: 'administration.subscription-plans.feature-list',
            title: 'Feature List',
            type: 'basic',
            icon: 'heroicons_outline:list-bullet',
            link: '/administration/features/list',
          },
          {
            id: 'administration.subscription-plans.create-feature',
            title: 'Create Feature',
            type: 'basic',
            icon: 'heroicons_outline:plus-circle',
            link: '/administration/features/add',
          },
        ],
      },
      {
        id: 'administration.access-control',
        title: 'Access Control',
        type: 'collapsable',
        icon: 'heroicons_outline:lock-closed',
        children: [
          {
            id: 'administration.access-control.module-feature-setup',
            title: 'Module Feature Setup',
            type: 'collapsable',
            icon: 'heroicons_outline:tag',
            children: [
              {
                id: 'administration.access-control.module-feature-setup.module-list',
                title: 'Module List',
                type: 'basic',
                icon: 'heroicons_outline:view-columns',
                link: '/administration/access-control/module-feature-setup/module-list',
              },
              {
                id: 'administration.access-control.module-feature-setup.feature-list',
                title: 'Feature List',
                type: 'basic',
                icon: 'heroicons_outline:puzzle-piece',
                link: '/administration/access-control/module-feature-setup/feature-list',
              },
              {
                id: 'administration.access-control.module-feature-setup.page-list',
                title: 'Page List',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/administration/user-management/role-management',
              },
            ],
          },
          {
            id: 'administration.access-control.list',
            title: 'Permission Tree ',
            type: 'basic',
            icon: 'heroicons_outline:rectangle-stack',
            link: 'permissions-management/list',
          },
          {
            id: 'administration.access-control.field-permission',
            title: 'Field Permission',
            type: 'basic',
            icon: 'heroicons_outline:adjustments-horizontal',
            link: '/administration/access-control/field-permission',
          },
        ],
      },
    ],
  },
  {
    id: 'troubleshooting',
    title: 'Troubleshooting',
    subtitle: '',
    type: 'group',
    icon: 'heroicons_outline:wrench-screwdriver',
    children: [],
  },
  {
    id: 'utilities',
    title: 'Utilities',
    subtitle: '',
    type: 'group',
    icon: 'heroicons_outline:bolt',
    children: [
      {
        id: 'utilities.print-settings',
        title: 'Print Settings',
        type: 'collapsable',
        icon: 'heroicons_outline:printer',
        children: [
          {
            id: 'utilities.print-settings.page',
            title: 'Print Settings',
            type: 'basic',
            icon: 'heroicons_outline:printer',
            link: '/utilities/print-settings',
          },
          {
            id: 'utilities.sales-billing-template',
            title: 'Sales Billing Template',
            type: 'basic',
            icon: 'heroicons_outline:document-text',
            link: '/utilities/sales-billing-template',
          },
          {
            id: 'utilities.purchase-billing-template',
            title: 'Purchase Billing Template',
            type: 'basic',
            icon: 'heroicons_outline:printer',
            link: '/utilities/purchase-order-template',
          },
        ],
      },
      {
        id: 'utilities.purchase-order-template',
        title: 'Purchase Order Template',
        type: 'basic',
        icon: 'heroicons_outline:shopping-cart',
        link: '/utilities/purchase-order-template',
      },
      {
        id: 'utilities.purchase-return-template',
        title: 'Purchase Return Template',
        type: 'basic',
        icon: 'heroicons_outline:arrow-uturn-left',
        link: '/utilities/purchase-return-template',
      },
      {
        id: 'utilities.saas-overview',
        title: 'SaaS Overview',
        type: 'basic',
        icon: 'heroicons_outline:building-office-2',
        link: '/saas-overview',
      },
    ],
  },
  {
    id: 'misc',
    title: 'Misc',
    subtitle: '',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    children: [
      {
        id: 'window',
        title: 'Window',
        subtitle: '',
        type: 'group',
        icon: 'heroicons_outline:window',
        children: [],
      },
      {
        id: 'help',
        title: 'Help',
        subtitle: '',
        type: 'group',
        icon: 'heroicons_outline:question-mark-circle',
        children: [],
      },
      {
        id: 'exit',
        title: 'Exit',
        subtitle: '',
        type: 'group',
        icon: 'heroicons_outline:arrow-left-on-rectangle',
        children: [
          {
            id: 'inventory.medicineMaster',
            title: 'Medicine Master',
            type: 'basic',
            icon: 'heroicons_outline:newspaper',
            link: '/item-ledger/medicine-master',
          },
          {
            id: 'billing.returnVoidBill',
            title: 'Batch Stock Management',
            type: 'basic',
            icon: 'heroicons_outline:chat-bubble-bottom-center-text',
            link: '/billing/void-bill',
          },
          {
            id: 'billing.draftBills',
            title: 'Add Stock (Purchase Entry)',
            type: 'basic',
            icon: 'heroicons_outline:user-group',
            link: '/billing/draft-bills',
          },
          {
            id: 'billing.reprintInvoice',
            title: 'Expiry Tracker',
            type: 'basic',
            icon: 'heroicons_outline:shopping-cart',
            link: '/billing/reprint-invoice',
          },
          {
            id: 'billing.creditBills',
            title: 'AI Reorder Suggestions',
            type: 'basic',
            icon: 'heroicons_outline:cloud',
            link: '/billing/credit-bills',
          },
        ],
      },
      {
        id: 'inventory',
        title: 'Masters / Settings',
        subtitle: '',
        type: 'group',
        icon: 'heroicons_outline:users',
        children: [
          {
            id: 'inventory.medicineMaster',
            title: 'Medicine Master',
            type: 'basic',
            icon: 'heroicons_outline:newspaper',
            link: '/item-ledger/medicine-master',
          },
          {
            id: 'billing.returnVoidBill',
            title: 'Batch Stock Management',
            type: 'basic',
            icon: 'heroicons_outline:chat-bubble-bottom-center-text',
            link: '/billing/void-bill',
          },
          {
            id: 'billing.draftBills',
            title: 'Add Stock (Purchase Entry)',
            type: 'basic',
            icon: 'heroicons_outline:user-group',
            link: '/billing/draft-bills',
          },
          {
            id: 'billing.reprintInvoice',
            title: 'Expiry Tracker',
            type: 'basic',
            icon: 'heroicons_outline:shopping-cart',
            link: '/billing/reprint-invoice',
          },
          {
            id: 'billing.creditBills',
            title: 'AI Reorder Suggestions',
            type: 'basic',
            icon: 'heroicons_outline:cloud',
            link: '/billing/credit-bills',
          },
        ],
      },
      {
        id: 'inventory',
        title: 'Sync & Logs',
        subtitle: '',
        type: 'group',
        icon: 'heroicons_outline:users',
        children: [
          {
            id: 'inventory.medicineMaster',
            title: 'Medicine Master',
            type: 'basic',
            icon: 'heroicons_outline:newspaper',
            link: '/item-ledger/medicine-master',
          },
          {
            id: 'billing.returnVoidBill',
            title: 'Batch Stock Management',
            type: 'basic',
            icon: 'heroicons_outline:chat-bubble-bottom-center-text',
            link: '/billing/void-bill',
          },
          {
            id: 'billing.draftBills',
            title: 'Add Stock (Purchase Entry)',
            type: 'basic',
            icon: 'heroicons_outline:user-group',
            link: '/billing/draft-bills',
          },
          {
            id: 'billing.reprintInvoice',
            title: 'Expiry Tracker',
            type: 'basic',
            icon: 'heroicons_outline:shopping-cart',
            link: '/billing/reprint-invoice',
          },
          {
            id: 'billing.creditBills',
            title: 'AI Reorder Suggestions',
            type: 'basic',
            icon: 'heroicons_outline:cloud',
            link: '/billing/credit-bills',
          },
        ],
      },
      {
        id: 'inventory',
        title: 'Supliers',
        subtitle: '',
        type: 'group',
        icon: 'heroicons_outline:users',
        children: [
          {
            id: 'inventory.medicineMaster',
            title: 'Medicine Master',
            type: 'basic',
            icon: 'heroicons_outline:newspaper',
            link: '/item-ledger/medicine-master',
          },
          {
            id: 'billing.returnVoidBill',
            title: 'Batch Stock Management',
            type: 'basic',
            icon: 'heroicons_outline:chat-bubble-bottom-center-text',
            link: '/billing/void-bill',
          },
          {
            id: 'billing.draftBills',
            title: 'Add Stock (Purchase Entry)',
            type: 'basic',
            icon: 'heroicons_outline:user-group',
            link: '/billing/draft-bills',
          },
          {
            id: 'billing.reprintInvoice',
            title: 'Expiry Tracker',
            type: 'basic',
            icon: 'heroicons_outline:shopping-cart',
            link: '/billing/reprint-invoice',
          },
          {
            id: 'billing.creditBills',
            title: 'AI Reorder Suggestions',
            type: 'basic',
            icon: 'heroicons_outline:cloud',
            link: '/billing/credit-bills',
          },
        ],
      },
      {
        id: 'inventory',
        title: 'Help / Support',
        subtitle: '',
        type: 'group',
        icon: 'heroicons_outline:users',
        children: [
          {
            id: 'inventory.medicineMaster',
            title: 'Medicine Master',
            type: 'basic',
            icon: 'heroicons_outline:newspaper',
            link: '/item-ledger/medicine-master',
          },
          {
            id: 'billing.returnVoidBill',
            title: 'Batch Stock Management',
            type: 'basic',
            icon: 'heroicons_outline:chat-bubble-bottom-center-text',
            link: '/billing/void-bill',
          },
          {
            id: 'billing.draftBills',
            title: 'Add Stock (Purchase Entry)',
            type: 'basic',
            icon: 'heroicons_outline:user-group',
            link: '/billing/draft-bills',
          },
          {
            id: 'billing.reprintInvoice',
            title: 'Expiry Tracker',
            type: 'basic',
            icon: 'heroicons_outline:shopping-cart',
            link: '/billing/reprint-invoice',
          },
          {
            id: 'billing.creditBills',
            title: 'AI Reorder Suggestions',
            type: 'basic',
            icon: 'heroicons_outline:cloud',
            link: '/billing/credit-bills',
          },
        ],
      },
    ],
  },
];
